import React, {Component} from 'react';
import {Route, Switch, Redirect} from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import Login from 'routes/Login/index'
import Index from 'routes/Index/index'
import './App.css'
import 'assets/font/iconfont.css'


function PrivateRoute({ isLogin, component: Component, ...rest }) {
  return (
    <Route {...rest} render={props =>
      isLogin ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
      )
    } />
  )
}


class App extends Component {
  render() {
    const { appStore } = this.props
    return (
      <Switch>
        <Route path='/login' render={props =>
          appStore.isLogin ? (
            <Redirect to='/admin' />
          ) : (
            <Login {...props} />
          )
        }/>
        <PrivateRoute path='/' isLogin={appStore.isLogin} component={Index}/>
      </Switch>
    )
  }
}

export default inject('appStore')(observer(App));



// WEBPACK FOOTER //
// ./src/App.js